import React from "react";
import { Button } from "reactstrap";
import { Trans } from "react-i18next";
import classNames from "classnames";

export const PrintButton = ({ className, ...props }) => (
  <Button
    color="primary"
    className={classNames("d-print-none", className)}
    onClick={() => window.print()}
    {...props}
  >
    <span className="fa fa-print" /> <Trans>Print</Trans>
  </Button>
);

export default PrintButton;
